import { Injectable } from '@angular/core';

type SlugRow = { id: string; slugs: Record<string, string> };

@Injectable({ providedIn: 'root' })
export class SlugService {
  private rows: SlugRow[] | null = null;

  private async load(): Promise<SlugRow[]> {
    if (this.rows) return this.rows;
    const res = await fetch('/assets/i18n/slug-index.json');
    this.rows = await res.json();
    return this.rows!;
  }

  async translateSlug(currentSlug: string, fromLang: string, toLang: string): Promise<string | null> {
    const rows = await this.load();
    // 1) trouver la ligne dont le slug[fromLang] correspond au slug courant
    const row = rows.find(r => (r.slugs[fromLang] || '').toLowerCase() === currentSlug.toLowerCase());
    if (!row) return null;
    // 2) retourner le slug cible si dispo
    return row.slugs[toLang] || null;
  }
}
